import { Action, Dispatch } from 'redux'
import { shopsRef } from 'firebase/index'
import { ShopType } from 'types/shop'
import { fetchShopAction } from 'reducks/shop/actions'

const fetchShop = (shopId: string) => {
  return async (dispatch: Dispatch<Action>) => {
    return shopsRef
      .doc(shopId)
      .get()
      .then((snapshot) => {
        const data = snapshot.data() as ShopType
        dispatch(
          fetchShopAction({
            card: undefined,
            contact: data.contact ?? '',
            name: data.name ?? '',
            responsible_person: data.responsible_person ?? '',
            shop_id: snapshot.id,
            stripe_account_id: data.stripe_account_id ?? '',
            stripe_customer_id: data.stripe_customer_id ?? '',
            stripe_payment_method_id: data.stripe_payment_method_id ?? '',
            invoice_business_name: data.invoice_business_name,
            invoice_number: data.invoice_number,
          })
        )
      })
      .catch((error: unknown) => {
        console.error(error)
      })
  }
}

export default fetchShop
